/*
 * @Author: LiuMeiYu
 * @Date: 2023-05-26 15:49:34
 * @LastEditors: LiuMeiYu
 * @LastEditTime: 2023-05-26 15:49:46
 * @FilePath: \nexcross_b\src\api\set.js
 * @Description: *
 * *
 * Copyright (c) 2023 by yihua, All Rights Reserved.
 */
import request from "@/utils/request";
// import service from "@/utils/request";
// import { getRefreshToken } from "@/utils/auth";

// 设置登录密码
export function setLoginPasswordApi(data) {
  return request({
    url: "pay/app-pay-merchant/update-password",
    method: "post",
    data,
  });
}
// 设置支付密码
export function setPaymentPasswordApi(data) {
  return request({
    url: "pay/app-pay-merchant/update-trans-password",
    method: "post",
    data,
  });
}
